import SubscriptionPlan from "./SubscriptionPlan";

enum Feature {
  ADVANCED_ROUTING = "advancedRouting",
  BUSINESS_CARD_SCANNER = "businessCardScanner",
  MILEAGE_TRACKER = "mileageTracker",
  RESOURCES = "resources",
  EMAIL = "email",
  PHI = "phi",
  DATA_MERGING = "dataMerging",
  DEMOGRAPHICS = "demographics",
  ONBOARDING = "onboarding",
  TERRITORIES = "territories",
  SMART_TERRITORIES = "smartTerritories",
  CUSTOM_DASHBOARDS = "cumul",
  HEALTHCARE_DATA = "healthcareData",
  EFFICIENCY_PACKAGE = "efficiencyPackage",
  LEAD_FINDER_ADVANCED = "leadFinderAdvanced",
  LEAD_FINDER_BASIC = "leadFinderBasic",
  LEAD_FINDER_ELITE = "leadFinderElite",
  LEAD_FINDER_PRO = "leadFinderPro",
  LEAD_FINDER_STARTER = "leadFinderStarter",
  AI_FIELD_AGENT = "aiFieldAgent",
  AI_EXECUTIVE_SUMMARIES = "aiExecutiveSummaries",
  REP_COACHING = "repCoaching",
  BESPOKE_REVENUE_INTELLIGENCE = "bespokeRevenueIntelligence",
}

// The one display order, sorted by card title. The current-features panel renders it as it
// stands, and a band renders it filtered to its own cards, so both surfaces order features the
// same way. The three Field Intelligence cards keep the order the design specifies and so sit last.
export const ALL_FEATURES = [
  Feature.CUSTOM_DASHBOARDS, // Advanced Reporting
  Feature.ADVANCED_ROUTING,
  Feature.AI_FIELD_AGENT,
  Feature.BUSINESS_CARD_SCANNER,
  Feature.DATA_MERGING,
  Feature.DEMOGRAPHICS,
  Feature.EMAIL,
  Feature.EFFICIENCY_PACKAGE, // Field Performance Package
  Feature.HEALTHCARE_DATA,
  Feature.LEAD_FINDER_ADVANCED,
  Feature.LEAD_FINDER_BASIC,
  Feature.LEAD_FINDER_ELITE,
  Feature.LEAD_FINDER_PRO,
  Feature.LEAD_FINDER_STARTER,
  Feature.TERRITORIES, // Manual Territories
  Feature.MILEAGE_TRACKER,
  Feature.ONBOARDING,
  Feature.PHI,
  Feature.RESOURCES,
  Feature.SMART_TERRITORIES,
  Feature.AI_EXECUTIVE_SUMMARIES,
  Feature.REP_COACHING,
  Feature.BESPOKE_REVENUE_INTELLIGENCE,
];

// Which band offers each card. A card with no entry is never offered, only ever owned: the legacy
// LEAD_FINDER_BASIC and LEAD_FINDER_PRO tiers, and LEAD_FINDER_STARTER, which no plan includes.
export const featurePlanMap: Partial<Record<Feature, SubscriptionPlan>> = {
  [Feature.ADVANCED_ROUTING]: SubscriptionPlan.ENTERPRISE,
  [Feature.AI_EXECUTIVE_SUMMARIES]: SubscriptionPlan.FIELD_INTELLIGENCE,
  [Feature.AI_FIELD_AGENT]: SubscriptionPlan.ENTERPRISE,
  [Feature.BESPOKE_REVENUE_INTELLIGENCE]: SubscriptionPlan.FIELD_INTELLIGENCE,
  [Feature.BUSINESS_CARD_SCANNER]: SubscriptionPlan.ENTERPRISE,
  [Feature.CUSTOM_DASHBOARDS]: SubscriptionPlan.ENTERPRISE,
  [Feature.DATA_MERGING]: SubscriptionPlan.ENTERPRISE,
  [Feature.DEMOGRAPHICS]: SubscriptionPlan.INDUSTRY_LEADER,
  [Feature.EFFICIENCY_PACKAGE]: SubscriptionPlan.ENTERPRISE,
  [Feature.EMAIL]: SubscriptionPlan.INDUSTRY_LEADER,
  [Feature.HEALTHCARE_DATA]: SubscriptionPlan.ENTERPRISE,
  [Feature.LEAD_FINDER_ADVANCED]: SubscriptionPlan.INDUSTRY_LEADER,
  [Feature.LEAD_FINDER_ELITE]: SubscriptionPlan.ENTERPRISE,
  [Feature.MILEAGE_TRACKER]: SubscriptionPlan.ENTERPRISE,
  [Feature.ONBOARDING]: SubscriptionPlan.ENTERPRISE,
  [Feature.PHI]: SubscriptionPlan.INDUSTRY_LEADER,
  [Feature.REP_COACHING]: SubscriptionPlan.FIELD_INTELLIGENCE,
  [Feature.RESOURCES]: SubscriptionPlan.ENTERPRISE,
  [Feature.SMART_TERRITORIES]: SubscriptionPlan.ENTERPRISE,
  [Feature.TERRITORIES]: SubscriptionPlan.INDUSTRY_LEADER,
};

// Carries the "New" badge, in the panel and in the bands alike.
export const NEW_FEATURES = [
  Feature.ADVANCED_ROUTING,
  Feature.AI_EXECUTIVE_SUMMARIES,
  Feature.AI_FIELD_AGENT,
  Feature.BESPOKE_REVENUE_INTELLIGENCE,
  Feature.BUSINESS_CARD_SCANNER,
  Feature.EFFICIENCY_PACKAGE,
  Feature.REP_COACHING,
];

export default Feature;
